import { ICustomerForecastDiffLastMonthData } from '../entities/customerForecastDiffLastMonth';
import { ICustomerForecastDiffLastMonthBusinessDataFactory } from './ICustomerForecastDiffLastMonthBusinessDataFactory';

/**
 * 内示前月差異情報を生成するファクトリ
 */
export class ICustomerForecastDiffLastMonthDataFactory {
  /**
   * 内示前月差異情報を生成する
   * @param initialData - 初期値
   */
  public static create(initialData: Partial<ICustomerForecastDiffLastMonthData> = {}): ICustomerForecastDiffLastMonthData {
    const customerForecastDiffLastMonthData: ICustomerForecastDiffLastMonthData = {
      ...ICustomerForecastDiffLastMonthBusinessDataFactory.create({ ...initialData }),
      customerForecastUpdateAt: initialData.customerForecastUpdateAt ?? 0,
      customerForecasts: initialData.customerForecasts ?? [],
    };
    return customerForecastDiffLastMonthData;
  }
}
